export const PRESENCE = {
  online: { label: "Online", color: "bg-emerald-400", text: "text-emerald-400", ring: "ring-emerald-400" },
  away: { label: "Away", color: "bg-amber-400", text: "text-amber-400", ring: "ring-amber-400" },
  busy: { label: "Busy", color: "bg-red-500", text: "text-red-400", ring: "ring-red-500" },
  offline: { label: "Offline", color: "bg-slate-600", text: "text-slate-500", ring: "ring-slate-600" },
};

export function presenceMeta(p) {
  return PRESENCE[p] || PRESENCE.offline;
}

// Wolf statuses mapped to presence colors
export const STATUS_PRESETS = [
  { label: "Howling", presence: "online" },
  { label: "Hunting", presence: "busy" },
  { label: "Resting in Den", presence: "away" },
];

export function presenceForStatus(label) {
  const p = STATUS_PRESETS.find((s) => s.label === label);
  return p ? p.presence : "online";
}
